import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useProxyConnection } from '../context/ProxyConnectionContext';

interface ProxyRequiredRouteProps {
  children: React.ReactNode;
}

/**
 * Blocks proxy-dependent routes until the local proxy agent is connected.
 */
const ProxyRequiredRoute: React.FC<ProxyRequiredRouteProps> = ({ children }) => {
  const { isChecking, initialCheckComplete } = useProxyConnection();

  // Block only the first foreground check at login/launch — not periodic rechecks
  // (those used to set isChecking and remount this page, which felt like a full refresh).
  if (!initialCheckComplete && isChecking) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProxyRequiredRoute;
